import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const localitiesService = new CachedService(entities.Orderadmin_Locations_Entity_Locality, '/locations/localities', HALApiService, createItemsData)
